// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero .carousel .carousel-inner .carousel-item {
  position: relative;
}

.hero .carousel .carousel-inner .carousel-item img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.hero .carousel .carousel-inner .carousel-caption {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  width: 1000%;
  height: 100%;
  text-shadow: 2px 2px black;
  font-stretch: 200%;
}

.hero .carousel .carousel-inner .carousel-caption h1 {
  margin: 0;
  font-weight: 600;
  font-size: 3.3rem;
  color: white;
}

.carousel-caption p {
  font-size: 1.3rem;
}

/* Section 1 */
.img-section-1 {
  width: 550px;
  height: 400px;
}

.section-content-1 {
  width: 60%;
}

.section-content-1 h1 {
  text-align: center;
}

/* Section 2 */
.section-content-2 {
  width: 60%;
  position: relative;
}

.section-content-2 .iframe-section {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

/* Section 3 */
.section-content-3 {
  width: 60%;
  position: relative;
}

.section-content-3 a {
  text-decoration: none;
  color: #000;
}

.section-content-3 a:hover {
  color: #327a6d;
  text-decoration: underline;
}

.section-content-3 .swiper-1 {
  width: 100%;
  height: 100%;
}

.section-content-3 .card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 350px;
}

.section-content-3 .swiper-pagination-1 {
  display: none;
}

.section-content-3 .swiper-button-prev-1,
.section-content-3 .swiper-button-next-1 {
  color: #327a6d;
}

.section-content-3 .section-card-content-3 .card img {
  object-fit: cover;
  width: 100%;
  height: 250px;
}

/* Section 4 */
.section-content-4 {
  width: 60vmax;
}

.section-content-4 canvas {
  width: 100%;
  height: 100%;
}

.section-content-4 .form-select {
  font-size: 1rem;
  text-align: left;
  max-width: 150px;
}

/* Section 5 */
.section-content-5 {
  width: 60%;
  position: relative;
}

.section-content-5 a {
  text-decoration: none;
  color: #000;
}

.section-content-5 a:hover {
  color: #327a6d;
  text-decoration: underline;
}

.section-content-5 .swiper-2 {
  width: 100%;
  height: 100%;
}

.section-content-5 .section-card-content-5 .card {
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  height: 350px;
  cursor: pointer;
}

.section-content-5 .section-card-content-5 .card:hover {
  transition: 0.2s ease-in;
}

.section-content-5 .section-card-content-5 .card img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.section-content-5 .swiper-pagination-2 {
  display: none;
}

.section-content-5 .swiper-button-prev-2,
.section-content-5 .swiper-button-next-2 {
  color: #327a6d;
}

/* Section 6 */
.section-content-6 {
  width: 60%;
  position: relative;
}
.section-content-6 .href-news {
  text-decoration: none;
  color: #000;
}

.section-content-6 .href-news:hover {
  color: #327a6d;
  text-decoration: underline;
}
.section-content-6 .swiper-3 {
  width: 100%;
  height: 100%;
}

.section-content-6 .section-card-content-6 .card {
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  height: 400px;
  cursor: pointer;
  border: none;
}

.section-content-6 .section-card-content-6 .card:hover {
  transition: 0.2s ease-in;
  color: #327a6d;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.section-content-6 .section-card-content-6 .card img {
  object-fit: cover;
  width: 100%;
  height: 150px;
}

.section-content-6 .swiper-pagination-3 {
  display: none;
}

.section-content-6 .swiper-button-prev-3,
.section-content-6 .swiper-button-next-3 {
  color: #327a6d;
}

@media (max-width: 1650px) {
  html {
    font-size: 85%;
  }
  .section-content-1 {
    width: 75%;
  }
  .section-inner-content-1 .img-section-1 {
    width: 450px;
    height: 300px;
  }
  .section-content-2 {
    width: 75%;
  }
  .section-content-3 {
    width: 75%;
  }
  .section-content-4 {
    width: 75%;
  }

  .section-content-5 {
    width: 75%;
  }

  .section-content-6 {
    width: 75%;
  }
  .section-content-6 .section-card-content-6 .card img {
    height: 190px;
  }
}

@media (min-width: 600px) and (max-width: 1080px) {
  .hero .section-content-1 .section-inner-content-1 {
    flex-wrap: wrap;
    text-align: center;
  }
  .hero .section-content-2 .iframe-section {
    padding-bottom: 100%;
  }

  .section-content-3 {
    text-align: center;
  }

  .section-content-3 .section-card-content-3 {
    flex-wrap: wrap;
    justify-content: center;
  }
  .section-content-3 .section-card-content-3 .card {
    width: 18rem;
  }
  .section-content-3 .section-card-content-3 .card img {
    height: 270px;
  }
  .section-content-4 {
    width: 100%;
  }
  .section-content-4 {
    text-align: center;
  }
  .section-content-4 .canvas-container {
    align-items: center;
    padding: 1rem;
  }
  .section-content-5 {
    text-align: center;
  }
  .section-content-6 {
    text-align: center;
  }
  .section-content-6 .section-card-content-6 .card img {
    height: 210px;
  }
}

@media (max-width: 580px) {
  html {
    font-size: 85%;
  }
  .hero .carousel .carousel-inner .carousel-caption h1 {
    font-size: 1.9rem;
  }
  .carousel-caption p {
    font-size: 0.8rem;
  }
  .hero .section-content-1 .section-inner-content-1 {
    flex-wrap: wrap;
    text-align: center;
  }

  .section-inner-content-1 .img-section-1 {
    width: 300px;
    height: 240px;
  }
  .hero .section-content-2 {
    text-align: center;
    width: 100%;
    padding: 1.5rem;
  }
  .section-content-2 h5 {
    font-size: 1rem;
  }
  .hero .section-content-2 .iframe-section {
    min-height: 70vh;
  }
  .section-content-3 {
    text-align: center;
  }
  .section-content-3 .section-card-content-3 {
    flex-wrap: wrap;
  }
  .section-content-3 .section-card-content-3 .card img {
    height: 280px;
  }
  .section-content-3 h5 {
    font-size: 1rem;
  }
  .section-content-4 {
    width: 100%;
    padding: 1rem;
  }
  .section-content-4 {
    text-align: center;
  }
  .section-content-4 .form-select {
    width: 90px;
  }
  .section-content-4 .canvas-container {
    align-items: center;
  }
  .section-content-4 h5 {
    font-size: 1rem;
  }
  .section-content-5 {
    text-align: center;
  }
  .section-content-5 h5 {
    font-size: 1rem;
  }
  .section-content-5 .section-card-content-5 {
    flex-wrap: wrap;
  }
  .section-content-6 {
    text-align: center;
  }
  .section-content-6 h5 {
    font-size: 1rem;
  }
  .section-content-6 .section-card-content-6 {
    flex-wrap: wrap;
  }
  .section-content-6 .section-card-content-6 .card img {
    height: 230px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".hero .carousel .carousel-inner .carousel-item {\r\n  position: relative;\r\n}\r\n\r\n.hero .carousel .carousel-inner .carousel-item img {\r\n  width: 100%;\r\n  height: 100vh;\r\n  object-fit: cover;\r\n}\r\n\r\n.hero .carousel .carousel-inner .carousel-caption {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 999;\r\n  width: 1000%;\r\n  height: 100%;\r\n  text-shadow: 2px 2px black;\r\n  font-stretch: 200%;\r\n}\r\n\r\n.hero .carousel .carousel-inner .carousel-caption h1 {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 3.3rem;\r\n  color: white;\r\n}\r\n\r\n.carousel-caption p {\r\n  font-size: 1.3rem;\r\n}\r\n\r\n/* Section 1 */\r\n.img-section-1 {\r\n  width: 550px;\r\n  height: 400px;\r\n}\r\n\r\n.section-content-1 {\r\n  width: 60%;\r\n}\r\n\r\n.section-content-1 h1 {\r\n  text-align: center;\r\n}\r\n\r\n/* Section 2 */\r\n.section-content-2 {\r\n  width: 60%;\r\n  position: relative;\r\n}\r\n\r\n.section-content-2 .iframe-section {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-bottom: 56.25%;\r\n  height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Section 3 */\r\n.section-content-3 {\r\n  width: 60%;\r\n  position: relative;\r\n}\r\n\r\n.section-content-3 a {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n.section-content-3 a:hover {\r\n  color: #327a6d;\r\n  text-decoration: underline;\r\n}\r\n\r\n.section-content-3 .swiper-1 {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.section-content-3 .card {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 350px;\r\n}\r\n\r\n.section-content-3 .swiper-pagination-1 {\r\n  display: none;\r\n}\r\n\r\n.section-content-3 .swiper-button-prev-1,\r\n.section-content-3 .swiper-button-next-1 {\r\n  color: #327a6d;\r\n}\r\n\r\n.section-content-3 .section-card-content-3 .card img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 250px;\r\n}\r\n\r\n/* Section 4 */\r\n.section-content-4 {\r\n  width: 60vmax;\r\n}\r\n\r\n.section-content-4 canvas {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.section-content-4 .form-select {\r\n  font-size: 1rem;\r\n  text-align: left;\r\n  max-width: 150px;\r\n}\r\n\r\n/* Section 5 */\r\n.section-content-5 {\r\n  width: 60%;\r\n  position: relative;\r\n}\r\n\r\n.section-content-5 a {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n.section-content-5 a:hover {\r\n  color: #327a6d;\r\n  text-decoration: underline;\r\n}\r\n\r\n.section-content-5 .swiper-2 {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.section-content-5 .section-card-content-5 .card {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: start;\r\n  width: 100%;\r\n  height: 350px;\r\n  cursor: pointer;\r\n}\r\n\r\n.section-content-5 .section-card-content-5 .card:hover {\r\n  transition: 0.2s ease-in;\r\n}\r\n\r\n.section-content-5 .section-card-content-5 .card img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.section-content-5 .swiper-pagination-2 {\r\n  display: none;\r\n}\r\n\r\n.section-content-5 .swiper-button-prev-2,\r\n.section-content-5 .swiper-button-next-2 {\r\n  color: #327a6d;\r\n}\r\n\r\n/* Section 6 */\r\n.section-content-6 {\r\n  width: 60%;\r\n  position: relative;\r\n}\r\n.section-content-6 .href-news {\r\n  text-decoration: none;\r\n  color: #000;\r\n}\r\n\r\n.section-content-6 .href-news:hover {\r\n  color: #327a6d;\r\n  text-decoration: underline;\r\n}\r\n.section-content-6 .swiper-3 {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.section-content-6 .section-card-content-6 .card {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: start;\r\n  width: 100%;\r\n  height: 400px;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.section-content-6 .section-card-content-6 .card:hover {\r\n  transition: 0.2s ease-in;\r\n  color: #327a6d;\r\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\r\n}\r\n\r\n.section-content-6 .section-card-content-6 .card img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 150px;\r\n}\r\n\r\n.section-content-6 .swiper-pagination-3 {\r\n  display: none;\r\n}\r\n\r\n.section-content-6 .swiper-button-prev-3,\r\n.section-content-6 .swiper-button-next-3 {\r\n  color: #327a6d;\r\n}\r\n\r\n@media (max-width: 1650px) {\r\n  html {\r\n    font-size: 85%;\r\n  }\r\n  .section-content-1 {\r\n    width: 75%;\r\n  }\r\n  .section-inner-content-1 .img-section-1 {\r\n    width: 450px;\r\n    height: 300px;\r\n  }\r\n  .section-content-2 {\r\n    width: 75%;\r\n  }\r\n  .section-content-3 {\r\n    width: 75%;\r\n  }\r\n  .section-content-4 {\r\n    width: 75%;\r\n  }\r\n\r\n  .section-content-5 {\r\n    width: 75%;\r\n  }\r\n\r\n  .section-content-6 {\r\n    width: 75%;\r\n  }\r\n  .section-content-6 .section-card-content-6 .card img {\r\n    height: 190px;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n  .hero .section-content-1 .section-inner-content-1 {\r\n    flex-wrap: wrap;\r\n    text-align: center;\r\n  }\r\n  .hero .section-content-2 .iframe-section {\r\n    padding-bottom: 100%;\r\n  }\r\n\r\n  .section-content-3 {\r\n    text-align: center;\r\n  }\r\n\r\n  .section-content-3 .section-card-content-3 {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  .section-content-3 .section-card-content-3 .card {\r\n    width: 18rem;\r\n  }\r\n  .section-content-3 .section-card-content-3 .card img {\r\n    height: 270px;\r\n  }\r\n  .section-content-4 {\r\n    width: 100%;\r\n  }\r\n  .section-content-4 {\r\n    text-align: center;\r\n  }\r\n  .section-content-4 .canvas-container {\r\n    align-items: center;\r\n    padding: 1rem;\r\n  }\r\n  .section-content-5 {\r\n    text-align: center;\r\n  }\r\n  .section-content-6 {\r\n    text-align: center;\r\n  }\r\n  .section-content-6 .section-card-content-6 .card img {\r\n    height: 210px;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  html {\r\n    font-size: 85%;\r\n  }\r\n  .hero .carousel .carousel-inner .carousel-caption h1 {\r\n    font-size: 1.9rem;\r\n  }\r\n  .carousel-caption p {\r\n    font-size: 0.8rem;\r\n  }\r\n  .hero .section-content-1 .section-inner-content-1 {\r\n    flex-wrap: wrap;\r\n    text-align: center;\r\n  }\r\n\r\n  .section-inner-content-1 .img-section-1 {\r\n    width: 300px;\r\n    height: 240px;\r\n  }\r\n  .hero .section-content-2 {\r\n    text-align: center;\r\n    width: 100%;\r\n    padding: 1.5rem;\r\n  }\r\n  .section-content-2 h5 {\r\n    font-size: 1rem;\r\n  }\r\n  .hero .section-content-2 .iframe-section {\r\n    min-height: 70vh;\r\n  }\r\n  .section-content-3 {\r\n    text-align: center;\r\n  }\r\n  .section-content-3 .section-card-content-3 {\r\n    flex-wrap: wrap;\r\n  }\r\n  .section-content-3 .section-card-content-3 .card img {\r\n    height: 280px;\r\n  }\r\n  .section-content-3 h5 {\r\n    font-size: 1rem;\r\n  }\r\n  .section-content-4 {\r\n    width: 100%;\r\n    padding: 1rem;\r\n  }\r\n  .section-content-4 {\r\n    text-align: center;\r\n  }\r\n  .section-content-4 .form-select {\r\n    width: 90px;\r\n  }\r\n  .section-content-4 .canvas-container {\r\n    align-items: center;\r\n  }\r\n  .section-content-4 h5 {\r\n    font-size: 1rem;\r\n  }\r\n  .section-content-5 {\r\n    text-align: center;\r\n  }\r\n  .section-content-5 h5 {\r\n    font-size: 1rem;\r\n  }\r\n  .section-content-5 .section-card-content-5 {\r\n    flex-wrap: wrap;\r\n  }\r\n  .section-content-6 {\r\n    text-align: center;\r\n  }\r\n  .section-content-6 h5 {\r\n    font-size: 1rem;\r\n  }\r\n  .section-content-6 .section-card-content-6 {\r\n    flex-wrap: wrap;\r\n  }\r\n  .section-content-6 .section-card-content-6 .card img {\r\n    height: 230px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
